<article class="highlighted-article">
  @if (article()?.image; as image) {
    <figure class="highlighted-article__crop">
      <img
        [attr.data-object-position]="image.anchor"
        [src]="image.absoluteUrl| resize: 900 : 900 : image.anchor || 'middlecenter'"
        [alt]="article()?.title"
      />
    </figure>
  }
  <main class="highlighted-article__content" [class.big--article]="(article()?.text || '').length >= 600">
    <svg
      preserveAspectRatio="none"
      class="highlighted-article__content__background blob-background"
      xmlns="http://www.w3.org/2000/svg"
      width="759"
      height="640"
      fill="none"
      viewBox="0 0 759 640"
    >
      <path class="blob-background__back" fill="#8CD270" [attr.d]="path" />
      <path class="blob-background__overlay" fill="url(#highlighted-article-background)" [attr.d]="path" />

      <!-- *ngIf="article.text.length < 600" -->

      <defs>
        <linearGradient id="highlighted-article-background" x1="645.3" x2="309" y1="799.6" y2="202.7" gradientUnits="userSpaceOnUse">
          <stop class="blob-background__gradient__stop" stop-color="#F1FB61" />
          <stop class="blob-background__gradient__stop1" offset="1" stop-color="#8CD270" stop-opacity="0" />
          <stop class="blob-background__gradient__stop2" offset="1" stop-color="#E5E86E" stop-opacity="0" />
        </linearGradient>
      </defs>
    </svg>

    <div class="highlighted-article__content__wrapper">
      <h1 class="h3 highlighted-article__title">{{ article()?.title }}</h1>
      <div class="highlighted-article__text">
        <p>{{ article()?.text }}</p>

        @if (article()?.url) {
          <a [href]="article()?.url" target="_blank" class="button button-link button-link--light">
            <span>{{ article()?.source }}</span>
            <fstr-icon anchor="icon-arrow-right"></fstr-icon>
          </a>
        }
      </div>
    </div>
  </main>
  <a [href]="article()?.url" target="_blank" class="h4 block-link highlighted-article__source text-secondary">{{ article()?.source }}</a>
</article>
